import { useEffect, useState } from "react";
import { getAllVideos } from "../../../../../API/Mediatheque/Videos/videosService";
import BreadCrumb from "../../../../../components/breadcrumb";
import Header from "../../../../../components/DashboardNavigation/header";
import Sidebar from "../../../../../components/DashboardNavigation/sidebar";
import { VideoData } from "../../../../../components/tables/videos-tables/video";

const breadcrumbItems = [
  { title: "Vidéos", link: "/admin-dashboard/mediatheque/videos" },
];
export default function Videos() {
  const [videos, setVideos] = useState<any[]>([]);
  const fetchData = async () => {
    const response = await getAllVideos();
    setVideos(response?.videos);
  };
  useEffect(() => {
    fetchData();
  }, []);

  return (
    <>
      <Header />
      <div className="flex h-screen overflow-hidden">
        <Sidebar />
        <div className="flex-1 p-4 pt-6 space-y-4 md:p-8">
          <BreadCrumb items={breadcrumbItems} />
          <VideoData data={videos} />
        </div>
      </div>
    </>
  );
}
